// extracted by mini-css-extract-plugin
module.exports = {"Cancelable_Pill_Wrapper":"CancelablePill_Cancelable_Pill_Wrapper__3ZAxw","Cancelable_Pill_Close_Icon":"CancelablePill_Cancelable_Pill_Close_Icon__13sCS"};